var _rect, _circle, _rect2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNoDevices({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 141,
    viewBox: "0 0 176 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 67,
    height: 105.256,
    stroke: "#D3D4D8",
    strokeWidth: 3,
    strokeDasharray: "5 6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 91,
    r: 48.5,
    fill: "#FAFAFA",
    stroke: "#D3D4D8",
    strokeWidth: 3,
    strokeDasharray: "5 6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 87.5,
    y: 8.5,
    width: 87,
    height: 87,
    rx: 18.5,
    fill: "#FAFAFA",
    stroke: "#D3D4D8",
    strokeWidth: 3,
    strokeMiterlimit: 5.75877,
    strokeDasharray: "5 6"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDevices);
export default __webpack_public_path__ + "static/media/no-devices.798dfd1f4336e45b7cd1fa89dcc6e3d6.svg";
export { ForwardRef as ReactComponent };